import { render } from "./MenuItemActions.vue?vue&type=template&id=71cf6ab3&scoped=true"
import script from "./MenuItemActions.vue?vue&type=script&lang=js"
export * from "./MenuItemActions.vue?vue&type=script&lang=js"

import "./MenuItemActions.vue?vue&type=style&index=0&id=71cf6ab3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cf6ab3"]])

export default __exports__